import { Button } from 'rsuite'
import cn from 'classnames'
import styles from './linkButton.module.scss'

const LinkButton = ({ children, $center, className, ...props }) =>
  (
    <Button
      {...props}
      className={cn(
        styles.linkButton,
        { [styles.linkButtonCenter]: $center },
        className
      )}
    >
      {children}
    </Button>
  )

export default LinkButton
